import DefaultElementNodeType from '../DefaultElementNodeType';
import {IMP_MIG_WORK_PACKAGE} from '../../metamodel/Concept';

export default class WorkPackageNodeType extends DefaultElementNodeType {
	static get typeName() {
		return IMP_MIG_WORK_PACKAGE;
	}
}
